import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiLock, FiUser, FiEye, FiEyeOff } from 'react-icons/fi';
import { useApp } from '../../context/AppContext';

const AdminLogin = () => {
  const { login } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    await new Promise(r => setTimeout(r, 600));
    const ok = login(form.username, form.password);
    if (ok) navigate('/admin/dashboard');
    else setError('Invalid credentials. Try admin /  SitePixel2024');
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative">
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 80% 80% at 50% -20%, rgba(127,4,155,0.2) 0%, rgba(13,8,16,0) 60%)' }} />
      <div className="glow-orb w-80 h-80 opacity-10 top-1/4 -left-20" style={{ background: '#7f049b' }} />

      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        className="relative z-10 glass-card p-10 w-full max-w-md mx-6"
      >
        <div className="text-center mb-10">
          <div className="w-14 h-14 rounded-2xl mx-auto mb-6 flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #7f049b, #1c0c19)' }}>
            <FiLock size={22} className="text-white" />
          </div>
          <h1 className="font-display text-4xl text-white mb-2">Admin Access</h1>
          <p className="font-body text-sm text-white/40">Sign in to the  SitePixel dashboard</p>
        </div>

        {error && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="mb-6 px-4 py-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 font-body text-sm text-center"
          >
            {error}
          </motion.div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="font-body text-xs text-white/40 uppercase tracking-widest mb-2 block">Username</label>
            <div className="relative">
              <FiUser className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30" size={15} />
              <input
                type="text"
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                placeholder="admin"
                className="w-full pl-11 pr-4 py-3 rounded-xl font-body text-sm bg-white/5 border border-white/10 focus:border-purple-500/50 text-white placeholder-white/20 focus:outline-none transition-colors"
              />
            </div>
          </div>

          <div>
            <label className="font-body text-xs text-white/40 uppercase tracking-widest mb-2 block">Password</label>
            <div className="relative">
              <FiLock className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30" size={15} />
              <input
                type={showPass ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••"
                className="w-full pl-11 pr-11 py-3 rounded-xl font-body text-sm bg-white/5 border border-white/10 focus:border-purple-500/50 text-white placeholder-white/20 focus:outline-none transition-colors"
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white/30 hover:text-white"
              >
                {showPass ? <FiEyeOff size={15} /> : <FiEye size={15} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-primary py-3.5 flex items-center justify-center gap-2"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : 'Sign In'}
          </button>
        </form>

      </motion.div>
    </div>
  );
};

export default AdminLogin;
